import React from 'react';
import { Link } from 'react-router-dom'
import { useUtils } from '../hooks/useUtils';

export const CircleLink = ( {circle} ) => {

  const { isEmptyUnpaid } = useUtils();

  return (
    <Link to={`/circles/${circle.id}`}>
      {isEmptyUnpaid({circle}) ? '> ' : ''}  {circle.identifier}
    </Link>
  )
}

export default CircleLink